import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

// BK-3229 R1 AC 3.1.2: Compose-tab inline strip shown when the active
// prompt was loaded from a Commission Library template — the
// MathTierWarning inside the Library tab only renders while the
// Commission category is selected in the dropdown, so this component
// covers the case where the user picked a Commission template from the
// "All" view (or has switched away from the Commission filter while the
// commission prompt is still in the textarea).
//
// Visibility is the caller's responsibility — pass `show` based on:
//   1. Active prompt is from the Commission category
//   2. Tier is still 'reasoning' (clears when user manually changes tier)
//   3. Textarea has content (clears when textarea is cleared)
const CommissionTierNotice = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className="alert alert-info d-flex align-items-start mt-2 mb-0 py-2 px-3"
      role="alert"
      data-testid="compose-commission-tier-notice"
    >
      <FontAwesomeIcon icon="fas fa-calculator" className="mr-2 mt-1" />
      <span>
        Commission analysis uses the Reasoning model. This may take 30-60
        seconds.
      </span>
    </div>
  );
};

CommissionTierNotice.propTypes = {
  show: PropTypes.bool,
};

export default CommissionTierNotice;
